// import React, { useEffect, useState } from 'react'
// import { MdArrowForwardIos } from "react-icons/md";
// // import { FaArrowRightLong } from "react-icons/fa6";
// import { FaArrowLeftLong } from "react-icons/fa6";
// import blogbg from '../assets/blogbg.jpg'
// // import image1 from '../assets/image1.jpg'
// import { Link, useLocation } from 'react-router-dom';
// import Footer from './Footer';
// import Navigation from './Navigation';

// const Blog2 = () => {
//     const location = useLocation();
//     const currentPath = location.pathname;
//     const [isVisible, setIsVisible] = useState(false);

//     useEffect(() => {
//         setIsVisible(true);
//     }, []);

//     return (
//         <>
//             <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
//                 <Navigation />
//             </div>
//             <div className="relative">
//                 <img src={blogbg} alt="Background" className="w-full h-[210px] object-cover transform transition-transform duration-1000 hover:scale-105" />

//                 <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-12 bg-black/40">
//                     <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
//                         Blog
//                     </h1>
//                 </div>
//             </div>

//             <div className="w-full">
//                 <div className="flex items-center space-x-2 px-4 xl:px-12 py-3 xl:py-5">
//                     <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
//                         <Link to="/" className="text-green-700 text-md md:text-lg">HOME</Link>
//                         <MdArrowForwardIos className="text-gray-600 text-sm mt-0.5" />
//                         <p className="uppercase text-md md:text-lg text-gray-700">Blog</p>
//                     </div>
//                 </div>
//                 <div className="border-t border-gray-300 mx-4 xl:mx-6"></div>
//             </div>

//             {/* <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-4 xl:px-12 py-4 mt-8">

//                 <div className="flex flex-col bg-white shadow rounded overflow-hidden mt-5">
//                     <div className="relative w-full">
//                         <img src={image1} alt="Home" className="w-full h-auto object-cover" />

//                         <Link to='/' className="absolute top-6 left-5 text-white bg-green-600 text-md font-semibold px-3 py-2 shadow hover:bg-green-700">
//                             Home Security
//                         </Link>
//                     </div>
//                     <div className="flex flex-col h-full p-4 px-4 xl:px-8 py-2 xl:py-8">
//                         <h1 className="text-lg lg:text-xl font-semibold text-black">
//                             #2 Three Important Things You Must Look For While Choosing Home Security System
//                         </h1>

//                         <h2 className="text-sm text-gray-700 mt-2">September 7, 2021  <a href="/" className="text-green-700 font-medium ml-2"> SekureAdmin</a></h2>

//                         <p className="text-gray-600 text-justify text-md mt-6">
//                             It is natural if you feel the need for improvising on your home’s security system. Mostly, homes are unguarded or have security guards. Now, in the age of technology advancement...
//                         </p>
//                         <div className="mt-auto">
//                             <Link to="/BlogPage">
//                                 <button className="flex items-center px-4 py-3 text-lg text-white font-medium rounded-md bg-green-700 hover:bg-black transition mt-8 gap-2">
//                                     Read More
//                                     <FaArrowRightLong className="w-4 h-4" />
//                                 </button>
//                             </Link>
//                         </div>
//                     </div>
//                 </div>
//             </div> */}

//             <div className="flex justify-center items-center p-16">
//                 <div className="flex gap-4">
//                     {/* Prev Arrow */}
//                     <Link to="/blog1">
//                         <button
//                             className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog1" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>
//                             <FaArrowLeftLong />
//                         </button>
//                     </Link>

//                     {/* Page 1 */}
//                     <Link to="/blog1">
//                         <button
//                             className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog1" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>
//                             1
//                         </button>
//                     </Link>

//                     {/* Page 2 */}
//                     <Link to="/Blog2">
//                         <button
//                             className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/Blog2" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>
//                             2
//                         </button>
//                     </Link>
//                 </div>
//             </div>

//             <div><Footer /></div>
//         </>
//     )
// }

// export default Blog2

import React, { useEffect, useState } from 'react'
import blogbg from '../assets/blogbg.jpg'
import common from "../assets/common.jpg"
import fireal from "../assets/fireal.jpg"
import fireala from "../assets/fireala.jpg"
import smoke from "../assets/smoke.jpg"
import nitrogen from "../assets/nitrogen.png"
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";
import Footer from './Footer'
import { Link, useLocation } from 'react-router-dom'
import Navigation from './Navigation'

const Blog = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <>
            {/* Navigation */}
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>

            {/* Banner */}
            <div className="relative">
                <img src={blogbg} alt="Background" className="w-full h-[210px] object-cover transform transition-transform duration-1000 hover:scale-105" />

                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Blog
                    </h1>
                </div>
            </div>

            {/* Breadcrumb */}
            <div className="w-full">
                <div className="flex items-center space-x-2 px-4 xl:px-20 py-5 xl:py-6">
                    <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                        <Link to="/" className="text-green-700 text-md md:text-lg">HOME</Link>
                        <MdArrowForwardIos className="text-gray-600 text-sm mt-0.5" />
                        <p className="uppercase text-md md:text-lg text-gray-700">Blog</p>
                    </div>
                </div>
                <div className="border-t border-gray-300 mx-4 xl:mx-16"></div>
            </div>

            {/* Blog Cards */}
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-4 xl:px-20 py-4 mt-5 mb-20">

                {/* Card Template */}
                {[
                    {
                        img: common,
                        title: "Common Devices for Addressable Systems",
                        link: "/BlogPage"
                    },

                    {
                        img: fireal,
                        title: "Fire Alarm System, N3060",
                        link: "/BlogPage2"
                    },

                    {
                        img: fireala,
                        title: "Fire Alarm System, N765",
                        link: "/BlogPage3"
                    },

                    {
                        img: nitrogen,
                        title: "Nitrogen Gas Suppression System",
                        link: "/BlogPage5"
                    },

                    {
                        img: smoke,
                        title: "Aspirating Super – High Sensitivity Smoke Detection System",
                        link: "/BlogPage6"
                    }

                ].map((card, index) => (
                    <div key={index} className="flex flex-col bg-white shadow rounded-md overflow-hidden mt-6 h-full transition duration-200 hover:scale-105">

                        <Link to={card.link}>
                            <div className="relative w-full group cursor-pointer">
                                <img
                                    src={card.img}
                                    alt={card.title}
                                    className="w-full h-48 md:h-52 lg:h-72 object-contain"
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition duration-300"></div>
                            </div>
                        </Link>

                        <div className="flex flex-col flex-grow px-4 xl:px-8 py-2 xl:py-8">
                            <h1 className="text-lg lg:text-xl font-semibold text-black">{card.title}</h1>

                            <div className="mt-auto">
                                <Link to={card.link}>
                                    <button className="flex items-center px-4 py-2 text-lg text-white font-medium rounded-md bg-green-700 hover:bg-green-800 transition gap-2">
                                        Read More
                                        <FaArrowRightLong className="w-4 h-4 mt-1" />
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}

            </div>

            {/* Pagination */}
            {/* <div className="flex justify-center items-center p-16">
                <div className="flex gap-4">
                    <Link to="/blog1">
                        <button className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog1" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>1</button>
                    </Link>
                    <Link to="/blog2">
                        <button className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog2" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>2</button>
                    </Link>
                    <Link to="/blog2">
                        <button className={`w-16 h-16 flex items-center justify-center text-3xl font-medium border-2 ${currentPath === "/blog2" ? "bg-green-600 text-white border-green-600" : "text-black border-gray-400"} hover:bg-green-700 hover:text-white hover:border-green-700 transition`}>
                            <FaArrowRightLong />
                        </button>
                    </Link>
                </div>
            </div> */}

            {/* Footer */}
            <Footer />
        </>
    )
}

export default Blog


